// extracted by mini-css-extract-plugin
export var active = "StarRating-module--active--788db";
export var inactive = "StarRating-module--inactive--9bc79";
export var star = "StarRating-module--star--99211";
export var starsContainer = "StarRating-module--starsContainer--25505";